import type { ErrorCode } from '@volee/api-client'

// Italian translation. Same `Record<ErrorCode, string>`: exhaustive per language.
export const IT_ERRORS: Record<ErrorCode, string> = {
  'error.unauthenticated': 'Sessione scaduta. Accedi di nuovo per continuare.',
  'error.forbidden': 'Il tuo profilo non ha i permessi per questa operazione.',
  'error.not_found': 'La risorsa richiesta non esiste.',
  'error.conflict': 'Operazione in conflitto con lo stato attuale dei dati.',
  'error.unprocessable': 'I dati inviati non possono essere elaborati.',
  'error.internal': 'Errore interno. Riprova fra qualche istante.',
  'error.http': 'Richiesta non valida.',
  'error.validation_failed': 'Alcuni campi non sono compilati correttamente.',
  'error.unique_violation': 'Questo valore è già stato usato.',
  'error.foreign_key_violation': 'Il riferimento indicato non esiste.',
  'error.check_violation': 'Un valore non rispetta i vincoli previsti.',
  'error.not_null_violation': 'Manca un campo obbligatorio.',
  'error.constraint_violation': 'I dati non rispettano un vincolo previsto.',
  'error.identity_provider_unreachable':
    'Il servizio di autenticazione non risponde. Riprova fra qualche istante.',
  'auth.credentials_missing': 'Credenziali assenti. Accedi per continuare.',
  'auth.token_invalid': 'Sessione non valida. Accedi di nuovo.',
  'auth.token_not_id': 'Sessione non valida. Accedi di nuovo.',
  'auth.account_not_linked': 'Questo account non è collegato a nessun profilo Volée.',
  'auth.account_deactivated': 'Questo account è disattivato.',
  'auth.staff_required': 'Il backoffice è riservato allo staff Volée.',
  'auth.admin_required': 'L’invito di nuove persone è riservato agli amministratori.',
  'auth.not_your_club': 'Questa società non è la vostra.',
  'auth.not_your_match': 'Questa partita non è di una delle vostre squadre.',
  'auth.not_your_team': 'Questa squadra non è la vostra.',
  'auth.not_your_person': 'Questa anagrafica non è la tua.',
  'auth.password_verification_required': 'Serve di nuovo la password dell’account.',
  'auth.password_wrong': 'Questa non è la password dell’account.',
  'error.storage_unavailable': 'Lo storage dei file non risponde. Riprova tra un momento.',
  'club.not_found': 'Società non trovata.',
  'club.legal_name_taken': 'Esiste già una società con questa ragione sociale.',
  'club.lnd_name_taken': 'Un’altra società porta già questo nome della federazione.',
  'club.logo_invalid_type': 'Il logo deve essere un’immagine PNG, JPEG o WebP.',
  'club.logo_too_large': 'Il file del logo è troppo grande.',
  'registration.document_invalid_type': 'Il documento deve essere un PDF o un’immagine.',
  'registration.document_too_large': 'Il file del documento è troppo grande.',
  'registration.document_unknown': 'Il file caricato non c’è più. Scegli di nuovo il documento.',
  'registration.already_pending': 'Per questo indirizzo c’è già una richiesta in revisione.',
  'registration.already_decided': 'Questa richiesta è già stata decisa.',
  'registration.not_awaiting_document': 'Questa richiesta non è in attesa di un documento.',
  'club.logo_missing': 'Questa società non ha un logo.',
  'club.cover_invalid_type': 'La copertina deve essere un’immagine PNG, JPEG o WebP.',
  'club.cover_too_large': 'Il file della copertina è troppo grande.',
  'club.cover_missing': 'Questa società non ha una copertina.',
  'team_invite_link.already_active':
    'Questa leva ha già un link attivo: ruotalo invece di crearne un altro.',
  'team_invite_link.not_found':
    'Questo link d’iscrizione non è più valido. Chiedine uno nuovo a chi te l’ha mandato.',
  'family_enrolment.already_pending': 'C’è già una richiesta in revisione per questo giocatore.',
  'family_enrolment.not_found': 'Questa richiesta non esiste più.',
  'family_enrolment.already_decided': 'Questa richiesta è già stata esaminata.',
  'family_enrolment.guardian_confirmation_required':
    'Sotto i 14 anni la richiesta si approva solo dopo la conferma di un genitore o di un tutore.',
  'family_enrolment.password_required': 'Scegli una password per il tuo accesso.',
  'family_enrolment.consent_required':
    'Per inviare la richiesta serve il consenso all’informativa.',
  'family_enrolment.verification_required':
    'Per confermare spunta la dichiarazione di aver verificato i dati.',
  'family_enrolment.sign_in_required':
    'Questa e-mail ha già un account Volée: entra per continuare.',
  'guardian_link.not_found': 'Questo link non esiste. Chiedi a chi te l’ha mandato di rimandarlo.',
  'guardian_link.expired':
    'Questo link è scaduto. Chiedi a chi te l’ha mandato di farne uno nuovo dalla sua pagina.',
  'guardian_link.closed': 'Su questa richiesta è già stata data una risposta.',
  'guardian_link.sign_in_required': 'Questa e-mail ha già un account Volée: entra per confermare.',
  'guardian_link.own_request':
    'Non puoi confermare la tua stessa richiesta: serve un genitore o un tutore.',
  'guardian_link.consent_required': 'Per confermare serve la presa visione dell’informativa.',
  'guardian_link.account_without_person':
    'Il tuo account non ha ancora un profilo completo. Contatta la società.',
  'guardian_link.guardian_under_age':
    'Il tutore è un adulto: con questo account non si conferma. Entra con quello di un genitore.',
  'follower.not_found': 'Questa persona non ti segue più.',
  'delegated_sign_in.unavailable':
    'Per ora non si può aggiungere un figlio a questo telefono. Riprova più tardi.',
  'delegated_sign_in.no_account': 'Tuo figlio non ha ancora un account suo da aggiungere qui.',
  'delegated_sign_in.rate_limited': 'Hai provato troppe volte in un’ora. Riprova più tardi.',
  'guardian_link.child_access_required': 'Scegli il nome utente e la password per tuo figlio.',
  'family_enrolment.email_required': 'Da 14 anni serve una mail tua: è il tuo accesso a Volée.',
  'family_enrolment.own_access_required':
    'Ha compiuto 14 anni e non ha ancora una mail sua: si approva quando l’avrà aggiunta dalla pagina della sua richiesta.',
  'account.username_invalid': 'Lettere, numeri e punto: da 4 a 20 caratteri.',
  'account.username_taken': 'Questo nome utente è già preso: scegline un altro.',
  'account.no_autonomy_notice': 'Non c’è nessun avviso da leggere per questo account.',
  'account.own_email_required': 'Prima aggiungi una mail tua: da 14 anni è il tuo accesso a Volée.',
  'child_access.not_found':
    'Questo figlio non ha un accesso con nome utente: la sua mail e la sua password sono sue.',
  'verification_code.invalid':
    'Il codice non va: controlla di averlo scritto bene, o chiedine uno nuovo.',
  'verification_code.too_many': 'Hai chiesto troppi codici in un’ora: riprova più tardi.',
  'account.email_in_use': 'Questa mail ha già un account Volée: scegline un’altra.',
  'account.has_a_mail': 'Questo account ha già una mail.',
  'privacy_notice.not_found': 'L’informativa non è disponibile in questo momento.',
  'parent_account.sign_in_required': 'Questa e-mail ha già un account Volée: entra per continuare.',
  'parent_account.consent_required':
    'Per creare l’account serve la presa visione dell’informativa.',
  'sign_up.persons_closed':
    'Giocatori e genitori entrano con l’invito o il link della propria società.',
  'kit.not_found': 'La società non ha questa divisa.',
  'kit.second_needs_first': 'La società deve avere la prima divisa prima della seconda.',
  'kit.first_needed_by_second': 'La prima divisa non si toglie finché la società ha la seconda.',
  'kit.secondary_color_required': 'Questo disegno vuole un secondo colore.',
  'kit.secondary_color_not_allowed': 'La tinta unita non ha un secondo colore.',
  'onboarding.not_done':
    'Qualche passo è ancora da fare: i primi passi si chiudono a voci tutte fatte.',
  'onboarding.no_teams': 'La società non ha ancora squadre da confermare.',
  'club.field_reserved_to_staff': 'Questo dato lo cambia Volée: scrivete a noi.',
  'club.pitch_not_linked': 'Questo campo non è associato alla società.',
  'team.not_found': 'Squadra non trovata.',
  'team.already_exists': 'Questa società ha già questa squadra.',
  'team.in_use':
    'Questa squadra è iscritta a un campionato o ha incarichi: non può essere eliminata.',
  'team.fields_locked_by_enrollments':
    'Questa squadra è iscritta a un girone di questa stagione: fascia, Under e genere non si cambiano più. Rimuovi prima l’iscrizione dalla scheda del girone.',
  'team.cover_invalid_type': 'La copertina deve essere un’immagine PNG, JPEG o WebP.',
  'team.cover_too_large': 'Il file della copertina è troppo grande.',
  'team.cover_missing': 'Questa squadra non ha una copertina.',
  'pitch.not_found': 'Campo non trovato.',
  'pitch.lnd_name_taken': 'Un’altro campo porta già questo nome della federazione.',
  'pitch.lnd_code_taken': 'Questo codice impianto è già di un altro campo.',
  'bulletin_source.not_found': 'Questa fonte di comunicati non esiste più.',
  'bulletin_source.name_taken': 'C’è già una fonte con questo nome.',
  'bulletin_source.url_taken': 'C’è già una fonte con questo indirizzo.',
  'bulletin_source.inactive': 'La fonte è spenta: accendila prima di controllarla.',
  'bulletin_check.running': 'C’è già un controllo in corso su questa fonte.',
  'club.alias_taken': 'Questo nome è già di una società.',
  'pitch.alias_taken': 'Questo nome è già di un campo.',
  'gateway.not_found': 'Gateway non trovato.',
  'gateway.hardware_id_taken': 'Esiste già un gateway con questo identificativo hardware.',
  'gateway.hostname_taken': 'Esiste già un gateway con questo hostname.',
  'gateway.placement_incomplete': 'Campo e data di installazione vanno indicati insieme.',
  'gateway.release_not_found':
    'Quella versione del gateway non è stata pubblicata su questo ambiente.',
  'gateway.release_untried':
    'Nessun kit acceso gira ancora la {version}: aggiornane prima uno dalla sua scheda.',
  'gateway.secrets_unavailable':
    'I segreti del kit non si possono leggere in questo momento: riprova fra qualche minuto.',
  'gateway.maintenance_pending':
    'Questa azione è già in attesa del kit: guarda l’elenco qui sotto.',
  'gateway.retired': 'Questo kit è ritirato: non si può più cambiare.',
  'intervention.not_found': 'Intervento non trovato.',
  'intervention.open': 'Questo kit ha già un intervento aperto: chiudilo o annullalo prima.',
  'intervention.not_cancellable':
    'Questo intervento è già partito, chiuso o annullato: non si può annullare.',
  'bench.not_the_kits_board':
    'Una SD nuova va nella scheda del kit stesso: questa scatola è un’altra scheda.',
  'bench.no_repair_pending': 'Questo kit non aspetta più una scheda: ricarica la pagina.',
  'gateway.silent':
    'Il kit non comunica: registra il cambio quando torna in linea, prima di staccare il pezzo.',
  'intervention.parts_mismatch': 'Dai un esito a ogni pezzo del kit, e solo a quelli.',
  'bench.tailscale_unavailable':
    'Tailscale non risponde: riprova fra qualche minuto; se si ripete, avvisa il team tecnico.',
  'bench.box_not_found':
    'La scatola non si fa più sentire: controlla che sia accesa e collegata al router, poi riprova.',
  'bench.box_busy':
    'Questa scatola ha già un lavoro: seguilo da questa pagina, o premi Riprova sul passo non riuscito.',
  'bench.router_code_mismatch':
    'Non è il codice del router collegato a questa scatola: scansiona l’etichetta del router che hai davanti.',
  'bench.job_not_found': 'Questo lavoro non esiste più: ricarica la pagina.',
  'bench.job_not_failed': 'Questo lavoro non è fermo su un errore: non c’è niente da riprovare.',
  'bench.job_wrong_state': 'Il lavoro non è nello stato che questa operazione richiede.',
  'bench.hello_too_large': 'La scatola ha mandato una richiesta troppo grande.',
  'bench.full': 'Troppe scatole al banco in questo momento.',
  'bench.not_configured': 'Questo ambiente non è ancora configurato per il banco.',
  'bench.no_open_job': 'Questa scatola non ha un lavoro aperto: premi Prepara dalla pagina Banco.',
  'camera.not_found': 'Telecamera non trovata.',
  'recording.not_found': 'Registrazione non trovata.',
  'camera.mac_address_taken': 'Esiste già una telecamera con questo indirizzo MAC.',
  'camera.serial_number_taken': 'Esiste già una telecamera con questo numero di serie.',
  'camera.uid_taken': 'Esiste già una telecamera con questo UID.',
  'player.not_found': 'Giocatore non trovato.',
  'person.not_found': 'Persona non trovata.',
  'person.already_exists':
    'Una persona con questo nome e questa data di nascita è già in anagrafica.',
  'person.tax_code_taken': 'Questo codice fiscale è già in anagrafica, su un’altra persona.',
  'person.tax_code_conflicts':
    'Questa persona è già in anagrafica con un altro codice fiscale. Controllate quale dei due è giusto.',
  'person.tax_code_required': 'Serve il codice fiscale: senza non si tessera nessuno.',
  'person.figc_number_taken': 'Questa matricola è già di un’altra persona.',
  'tabulato.file_missing': 'Scegliete almeno un tabulato.',
  'tabulato.unreadable':
    'Questo file non si apre come un tabulato: caricate l’.xlsx scaricato dal portale della LND.',
  'tabulato.columns_unexpected':
    'Questo file non è un tabulato della LND: le colonne non sono quelle che ci aspettiamo. Non abbiamo caricato niente.',
  'tabulato.too_large': 'Il file è troppo grande per essere un tabulato.',
  'tabulato.too_many_rows':
    'Carichiamo al massimo {limit} righe per volta, e questi tabulati ne hanno di più.',
  'tabulato.too_many_files':
    'Carichiamo al massimo {limit} file per volta: unite le categorie, o caricate il tabulato intero.',
  'tabulato.correction_unknown_row':
    'Una correzione riguarda una riga che il tabulato non ha: rifate l’anteprima.',
  'tabulato.changed': 'Il file è cambiato: rifate l’anteprima.',
  'person.field_reserved_to_staff': 'Solo lo staff Volée può cambiare questo campo.',
  'person.minor_official_and_player': 'Un minorenne non può essere insieme tesserato e dirigente.',
  'player.field_reserved_to_the_club': 'Questo campo lo scrive la società del giocatore.',
  'player.field_reserved_to_the_player': 'Chi legge la sua pagina lo decide il giocatore.',
  'player.photo_invalid_type': 'La foto deve essere un’immagine PNG, JPEG o WebP.',
  'player.photo_too_large': 'Il file della foto è troppo grande.',
  'player.photo_missing': 'Questo giocatore non ha una foto.',
  'staff.photo_invalid_type': 'La foto deve essere un’immagine PNG, JPEG o WebP.',
  'staff.photo_too_large': 'Il file della foto è troppo grande.',
  'staff.photo_missing': 'Non c’è nessuna foto da togliere.',
  'profile.not_public': 'Questo giocatore non mostra il proprio profilo.',
  'registration.player_already_registered':
    'Già tesserato per questa stagione. Serve lo svincolo dalla società di provenienza.',
  'registration.not_found': 'Tesseramento non trovato.',
  'registration.after_season_end': 'La data di tesseramento cade dopo la fine di questa stagione.',
  'registration.release_before_registration':
    'La data di svincolo non può precedere quella di tesseramento.',
  'registration.release_in_the_future': 'La data di svincolo non può essere nel futuro.',
  'registration.season_not_current': 'Questo tesseramento è di un’altra stagione: lo cambia Volée.',
  'registration.field_reserved_to_staff': 'La data di tesseramento la cambia Volée.',
  'season.not_found': 'Questa stagione non esiste.',
  'season.bounds_conflict': 'Ci sono righe di questa stagione datate dopo il confine indicato.',
  'season.overlaps': 'Queste date si sovrappongono a un’altra stagione.',
  'season.dates_out_of_order': 'Una stagione non può finire prima di cominciare.',
  'league_category.not_found': 'Categoria non trovata.',
  'league_category.already_exists':
    'Esiste già una categoria con questa fascia, Under, livello e genere.',
  'league_category.in_use': 'Questa categoria ha già dei gironi: non può essere eliminata.',
  'league_category.fields_locked_by_groups':
    'La categoria ha già {group_count} gironi: fascia, Under, livello e genere non si cambiano più.',
  'league_group.not_found': 'Girone non trovato.',
  'league_group.already_exists':
    'Esiste già un girone con questo codice per questa categoria e stagione.',
  'league_group.in_use': 'Questo girone ha squadre iscritte: non può essere eliminato.',
  'enrollment.not_found': 'Iscrizione non trovata.',
  'enrollment.already_exists': 'Questa squadra è già iscritta a questo girone.',
  'enrollment.team_category_mismatch':
    'Questa squadra non corrisponde al girone: serve {age_group}, {under_age}, {gender}.',
  'enrollment.in_use': 'Questa iscrizione ha partite o convocazioni: non può essere rimossa.',

  'match.not_found': 'Partita non trovata.',
  'match.already_exists': 'Queste due squadre si incontrano già in questo turno.',
  'match.in_use': 'Questa partita ha una registrazione collegata: non può essere eliminata.',
  'match.sides_equal':
    'Una squadra non può giocare contro sé stessa: scegline un’altra in trasferta.',
  'match.side_not_in_group': 'Questa squadra non è iscritta a questo girone.',
  'match.side_withdrawn': 'Questa squadra si è ritirata: non può ricevere partite nuove.',
  'match.side_already_plays_that_matchday': 'Questa squadra gioca già alla giornata {matchday}.',
  'match.already_played': 'Questa partita è stata giocata: non si elimina e non si riprogramma.',
  'match.kickoff_before_season':
    'Il calcio d’inizio è prima dell’inizio della stagione {season_year}, il {starts_on}.',
  'match_change_report.not_found': 'Questa segnalazione non esiste.',
  'match_change_report.match_played':
    'La partita è già stata giocata: non si segnala più un cambio.',
  'match_change_report.says_nothing':
    'Dite almeno una cosa che cambia: la data, il campo, o che è rinviata.',
  'match_change_report.postponed_with_date':
    'Una partita rinviata a data da destinarsi non ha una nuova data.',
  'match_change_report.already_closed': 'Questa segnalazione è già stata chiusa.',
  'team_sheet.side_not_in_match': 'Questo lato non appartiene a questa partita.',
  'team_sheet.shirt_duplicated': 'Due convocati hanno lo stesso numero di maglia.',
  'team_sheet.too_many_starters': 'Non si possono avere più di 11 titolari.',
  'team_sheet.too_many_call_ups': 'Non si possono convocare più di 20 giocatori.',
  'team_sheet.captaincy_duplicated': 'Il ruolo di capitano o vice è assegnato due volte.',
  'team_sheet.no_call_ups': 'Non è convocato nessuno: per pubblicare serve almeno un giocatore.',
  'team_sheet.call_ups_locked':
    'La partita è cominciata: una convocazione pubblicata non cambia più chi è convocato, solo i numeri.',
  'team_sheet.details_locked':
    'La partita è cominciata: il ritrovo e le note della convocazione non cambiano più.',
  'team_sheet.locked_by_analysis':
    'La convocazione è già partita per l’analisi: i numeri non cambiano più.',
  'team_sheet.call_up_not_found': 'Questo convocato non c’è in questa partita.',
  'team_sheet.not_published':
    'La convocazione non è ancora pubblicata: per ora non c’è niente a cui rispondere.',
  'team_sheet.answers_closed': 'La partita è cominciata: la risposta non si cambia più.',
  'team_sheet.registration_not_in_club': 'Questa persona non è tesserata con questa società.',
  'team_sheet.registration_repeated': 'Lo stesso tesserato è convocato due volte.',
  'team_sheet.club_kit_missing': 'La società non ha la divisa scelta per questa partita.',
  'team_sheet.team_kit_missing': 'La squadra non ha la divisa scelta per questa partita.',
  'team_sheet.meeting_place_without_time':
    'Il luogo del ritrovo vuole anche l’ora: indicate l’ora, o togliete il luogo.',
  'appointment.already_exists': 'Questo incarico è già assegnato per la stagione.',
  'appointment.not_found': 'Incarico non trovato.',
  'appointment.already_ended': 'Questo incarico è già concluso.',
  'appointment.role_forbids_team': 'Questo ruolo è di società e non prende una squadra.',
  'appointment.field_reserved_to_staff': 'Questo dato lo cambia Volée.',
  'appointment.last_official': 'La società resterebbe senza dirigenti di società.',
  'appointment.end_after_season': 'La data di fine è successiva alla fine della stagione.',
  'appointment.seats_full': 'I due posti di squadra sono occupati: liberatene uno.',
  'appointment.officials_full': 'I due posti di società sono occupati: liberatene uno.',
  'appointment.seat_without_team': 'Per dare un posto di squadra scegliete la squadra.',
  'appointment.not_on_a_team': 'Questo incarico non è su una squadra.',
  'appointment.seat_already_held': 'Questa persona ha già un posto su questa squadra.',
  'appointment.official_takes_no_team_seat':
    'Un dirigente di società non occupa un posto di squadra.',
  'team.not_in_club': 'Quella squadra appartiene a un’altra società.',
  'team.player_already_in_roster': 'Questo giocatore è già nella rosa.',
  'team.player_not_in_roster': 'Questo giocatore non è nella rosa.',
  'registration.not_in_club': 'Questo tesserato non è della vostra società.',
  'registration.released': 'Questo giocatore è svincolato: non può entrare in una rosa.',
  'registration.not_in_season': 'Questo tesseramento è di un’altra stagione.',
  'registration.repeated': 'Lo stesso giocatore è selezionato due volte.',
  'registration.already_in_a_team':
    'Questo tesserato è già nella rosa di un’altra squadra: toglilo da quella prima.',
  'invitation.not_found': 'Invito non trovato.',
  'invitation.already_settled': 'Questo invito è già stato accettato o revocato.',
  'invitation.already_pending':
    "C'è già un invito in attesa per questo indirizzo e questo ruolo: rimandalo dalla lista.",
  'invitation.person_id_reserved': "Solo Volée può scegliere una persona dall'anagrafica.",
  'invitation.email_not_the_account':
    "Questa persona ha già un account: l'invito va al suo indirizzo.",
  'invitation.team_required': 'Si invita solo su un posto: scegliete la squadra.',
  'invitation.sign_in_required':
    "Questo indirizzo ha già un account Volée: accedi per accettare l'incarico.",
  'invitation.other_account':
    "L'invito è per un altro account: esci e accedi con l'indirizzo a cui è arrivato.",
  'invitation.no_account':
    'Questo indirizzo non ha ancora un account: completa i tuoi dati per crearlo.',
  'activation.person_has_account':
    'Esiste già un account con questo nome e questa data di nascita. Se è il tuo, accedi con quello e chiedi a chi ti ha invitato di usare il suo indirizzo.',
  'activation.person_at_another_address':
    "In anagrafica c'è già una persona con questo nome e questa data di nascita. Chiedi a chi ti ha invitato di farlo dalla tua scheda, o a Volée.",
  'invitation.token_unknown': 'Nessun invito corrisponde a quel link.',
  'invitation.expired': 'Quell’invito è scaduto.',
  'invitation.already_accepted': 'Quell’invito è già stato accettato.',
  'invitation.revoked': 'Quell’invito è stato revocato.',
  'account.not_found': 'Questo account non esiste.',
  'account.no_identity': 'Questo account non ha ancora un’identità di accesso.',
  'account.email_taken': 'Esiste già un account Volée con questa email.',
  'account.bound_to_another_person':
    'Questo indirizzo è già l’account di un’altra persona: invitala all’indirizzo con cui è già in Volée, oppure sposta prima l’account.',
  'account.person_already_bound':
    'Questa persona ha già un account Volée con un altro indirizzo: usa quello, oppure sposta prima l’account.',
  'account.identity_already_exists': 'Questa email esiste già nel provider di identità.',
  'account.password_rejected': 'La password scelta non rispetta la policy del pool.',
  'staff.identity_already_exists':
    'Questa email esiste nel provider di identità ma non in Volée: serve un intervento tecnico.',
  'staff.invite_quota_exceeded':
    'Non è stato possibile inviare l’email di invito: potrebbe essere stato raggiunto il limite giornaliero. Riprova più tardi.',
  'subscription.not_a_player': 'Il piano si attiva solo per un giocatore tesserato.',
  'subscription.not_a_guardian':
    'Il piano di un giocatore lo attiva solo lui stesso o un suo genitore.',
  'subscription.guardian_pays': 'Sotto i 14 anni il piano lo attiva un tuo genitore o tutore.',
  'subscription.already_active': 'Questo giocatore ha già un piano attivo.',
  'subscription.not_the_payer': 'Solo chi paga il piano può modificarlo.',
  'subscription.not_active': 'Questo piano non è più attivo.',
  'billing.provider_unavailable': 'Il servizio di pagamento non risponde. Riprova tra poco.',
  'match_analysis.no_video':
    'La partita non si può ancora inviare: non è stato caricato nessun video.',
  'match_analysis.no_published_team_sheet':
    'La partita non si può ancora inviare: nessuna delle due squadre ha pubblicato la convocazione.',
  'match_analysis.provider_unavailable': 'Il servizio di analisi non risponde. Riprova tra poco.',
  'match_analysis.switch_unavailable':
    "L'invio ad analisi è spento in questo ambiente e non si può accendere da qui.",
  'match_analysis.provider_refused':
    'Il servizio di analisi ha rifiutato la partita. I dettagli sono nei log.',
  'match_analysis.unknown_match_format':
    'La partita non si può inviare: la categoria della squadra di casa non ha un formato di gara noto (giocatori e tempi).',
  'category.not_admitted':
    'Questa categoria non è tra quelle ammesse: sceglila dall’elenco. Per il femminile ci sono Under 15, Under 17, Under 19 e Seniores.',
  'highlights.not_your_library':
    'Solo il giocatore e i suoi tutori cambiano le clip in evidenza, i preferiti e le playlist.',
  'highlights.clip_not_found': 'Questa clip non c’è più.',
  'highlights.playlist_not_found': 'Questa playlist non c’è più.',
  'highlights.plan_required': 'In evidenza, preferiti e playlist vogliono il piano.',
  'webhook.bad_signature': 'Firma del webhook non valida.',
}

export const IT_UNKNOWN_ERROR = 'Si è verificato un errore. Riprova fra qualche istante.'

export const IT_NETWORK_ERROR = 'Connessione non disponibile. Controlla la rete e riprova.'
